import React, { useState } from "react";
import ViewMore from "./ViewMore";
import NuAmount from "../../../../../../Components/Utils/NuAmount";

const ExpandableManpower = ({
  data,
  getData,
  Type,
  titleId,
  Role,
  selectedExpandedItems,
  onExpandedCheckboxChange,
  projectId,
}) => {
  return (
    <>
      {data.map((item, index) => (
        <tr
          className={`w-[100%] even:bg-white odd:bg-gray-50 text-xs font-normal text-[#71797E]`}
          key={index}
        >
          <td className=" w-[5%] py-3 px-1">
            <div className=" w-full gap-1 flex">
              <input
                type="checkbox"
                checked={
                  selectedExpandedItems[titleId]?.includes(item.id) || false
                }
                onChange={() => onExpandedCheckboxChange(titleId, item.id)}
              />
              {index + 1}
            </div>
          </td>
          <td className=" w-[10%] py-3 px-1">{item?.role || "-"}</td>
          <td className=" w-[10%] py-3 px-1">
            {item?.type == 0 ? "Own" : "Rental" || "-"}
          </td>
          <td className=" w-[10%] py-3 px-1">{item?.Planned_days || "-"}</td>
          <td className=" w-[10%] py-3 px-1">{item?.actual_days || "-"}</td>
          <td className=" w-[10%] py-3 px-1">{item?.budget_quantity || "-"}</td>
          <td className=" w-[10%] py-3 px-1">
            {<NuAmount value={item?.budget_Price || 0} />}
          </td>
          <td className=" w-[10%] py-3 px-1">{item?.actual_quantity || "-"}</td>
          <td className=" w-[10%] py-3 px-1">
            {<NuAmount value={item?.actual_Price || 0} />}
          </td>
          <td className=" w-[10%] py-3 px-1">
            {<NuAmount value={item?.amount || 0} />}
          </td>
          <td className=" w-[5%] py-3 pl-3">
            <ViewMore
              id={titleId || ""}
              getData={getData}
              data={item}
              projectId={projectId}
              Type={Type}
              Role={Role}
            />
          </td>
        </tr>
      ))}
    </>
  );
};

export default ExpandableManpower;
